import React, { useEffect, useState } from 'react';

import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import MoralPerson from '../formSections/MoralPerson';
import PhysicalPerson from '../formSections/PhysicalPerson';
import PersonType from '../formSections/PersonType';
import FieldRadioGroup from '../commons/FieldRadioGroup';
import Button from '../commons/Button';

import { form5Transaction } from '../../store/forms/form5-actions';

import { makeValuesForm4 } from '../../utils/form';
import { form4FetchCatalogs } from '../../store/catalogs-actions';
import { doNavigation } from '../../utils/helper-functions';
import { uiActions } from '../../store/ui-slice';
// Use the same validations than the form4
import { FORM4_VALIDATION_SCHEMA } from '../../constants/validation-schemas';
import { PHYSICAL_PERSON_VALUE, MORAL_PERSON_VALUE } from '../../constants/constants';

const Form5 = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.appConfig.appToken);
  const storePersonType = useSelector((state) => state.form5.data.personType);
  const storeSamePerson = useSelector((state) => state.form5.data.samePerson);
  // Person type 1 = Física, person type 2 = Moral
  const [personType, setPersonType] = useState(storePersonType);
  const [samePerson, setSamePerson] = useState(storeSamePerson);
  const navigate = useNavigate();
  const currentStep = useSelector((state) => state.appConfig.quoterCurrentStep);
  const form5State = useSelector((state) => state.form5.data);

  const submitHandler = (values) => {
    if (values.samePerson === 'yes') {
      dispatch(form5Transaction({ samePerson: 'yes' }, currentStep, navigate));
    } else {
      const payload = { ...makeValuesForm4(values), samePerson: 'no' };
      dispatch(form5Transaction(payload, currentStep, navigate));
    }
  };

  const navigationHandler = (direction) => {
    doNavigation(currentStep, direction, navigate, dispatch, uiActions, true);
  };

  const onChangePersonType = (value) => {
    setPersonType(value);
  };

  const splitStoreValues = (values) => {
    let splitValues = {};
    Object.keys(values).forEach((key) => {
      splitValues = { ...splitValues, ...values[key] };
    });

    splitValues.personType = values.personType;
    splitValues.samePerson = values.samePerson;

    return splitValues;
  };

  const handleChangeSamePerson = (value, validateForm) => {
    setTimeout(validateForm, 15);
    setSamePerson(value);
  };

  useEffect(() => {
    if (token) {
      dispatch(form4FetchCatalogs(token));
    }
  }, [dispatch, token]);

  return (
    <Formik
      onSubmit={submitHandler}
      enableReinitialize
      initialValues={splitStoreValues(form5State)}
      validateOnMount={!form5State.wasValidatedBefore}
      validationSchema={Yup.object().shape(samePerson === 'yes' ? {} : FORM4_VALIDATION_SCHEMA)}>
      {({ isValid }) => {
        return (
          <Form className="quoter-form">
            <h2 className="form-title">
              Datos del contratante
            </h2>
            <p className="form-subtitle text-center">
              Ingresa los datos para continuar con la emisión de la póliza
            </p>
            <div className="form-fields">
              <h3>
                Datos inciales del contratante
              </h3>
              <hr className="solid" />
              <FieldRadioGroup
                inputLabel="¿El asegurado es el mismo que el contratante?"
                additionalAction={handleChangeSamePerson}
                required
                radios={[{ label: 'Si', value: 'yes' }]}
                name="samePerson"
                defaultValue="yes"
                disabled />
            </div>
            {samePerson === 'no' && (
              <div>
                <PersonType onChange={onChangePersonType} isInsuredPerson={false} />
                {personType === PHYSICAL_PERSON_VALUE && <PhysicalPerson isInsuredPerson={false} />}
                {personType === MORAL_PERSON_VALUE && <MoralPerson isInsuredPerson={false} />}
              </div>
            )}
            <div className="form-buttons">
              <Button
                onClick={() => navigationHandler('backward')}
                type="button"
                label="Regresar"
                buttonClasses="-secondary"
                iconPosition="before"
                iconClasses="arrow-left" />
              <Button
                type="submit"
                disabled={!isValid}
                label="Continuar"
                iconClasses="arrow-right" />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default Form5;
